import { getWindow } from "./getWindow";

const REPORTED_BY_APPLICATION = "__wcomReportedByApplication";

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null;

export const markAsReportedByApplication = (error: unknown): void => {
    if (!isRecord(error)) {
        return;
    }

    try {
        Object.defineProperty(error, REPORTED_BY_APPLICATION, {
            value: true,
            enumerable: false,
            configurable: true,
            writable: true,
        });
    } catch {
        // Frozen or sealed errors cannot be marked and are dropped instead.
    }
};

export const isApplicationError = (error: unknown): boolean =>
    isRecord(error) && error[REPORTED_BY_APPLICATION] === true;

export const registerNewrelicErrorHandler = (): void => {
    getWindow()?.newrelic?.setErrorHandler(
        (error) => !isApplicationError(error)
    );
};
